import { Routes } from '@angular/router';
import { userResolver } from './infrastructure/resolvers/user.resolver';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'registration',
        loadComponent: () =>
            import('./features/registration/ui/pages/registration/registration.component').then((c) => c.RegistrationComponent),
        loadChildren: () => import('./features/registration/registration-routes').then((routes) => routes.registrationRoutes),
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./features/authentication/ui/pages/authentication/authentication.component').then((c) => c.AuthenticationComponent),
        loadChildren: () => import('./features/authentication/authentication-routes').then((routes) => routes.authenticationRoutes),
    },
    // {
    //     path: 'dashboard',
    //     loadComponent: () => import('./features/dashboard/ui/pages/dashboard.component').then((c) => c.DashboardComponent),
    //     loadChildren: () => import('./features/dashboard/dashboard-routes').then((routes) => routes.DashboardRoutes),
    //     // canMatch: [authGuard],
    //     resolve: { user: userResolver },
    // },
    {
        path: 'vehicles',
        loadComponent: () => import('./features/vehicles/ui/pages/vehicles/vehicles.component').then((c) => c.VehiclesComponent),
        loadChildren: () => import('./features/vehicles/vehicles-routes').then((routes) => routes.vehiclesRoutes),
        // canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    // {
    //     path: 'developers',
    //     loadComponent: () => import('./features/developers/ui/pages/developer.component').then((c) => c.DeveloperComponent),
    //     loadChildren: () => import('./features/developers/developers-routes').then((routes) => routes.DeveloperRoutes),
    //     // canMatch: [authGuard],
    //     resolve: { user: userResolver },
    // },
    {
        path: 'trips',
        loadComponent: () => import('./features/activity/ui/pages/activity.component').then((c) => c.ActivityComponent),
        loadChildren: () => import('./features/activity/activity-routes').then((routes) => routes.activityRoutes),
        // canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    {
        path: 'invoices',
        loadComponent: () => import('./features/invoices/pages/invoices.component').then((c) => c.InvoicesComponent),
        loadChildren: () => import('./features/invoices/invoices-routes').then((routes) => routes.invoicesRoutes),
        // canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    {
        path: 'settings',
        loadComponent: () => import('./features/settings/ui/pages/settings/settings.component').then((c) => c.SettingsComponent),
        loadChildren: () => import('./features/settings/settings-routes').then((routes) => routes.settingsRoutes),
        // canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    {
        path: 'user',
        loadComponent: () =>
            import('./features/user-settings/ui/pages/user-settings/user-settings.component').then((c) => c.UserSettingsComponent),
        loadChildren: () => import('./features/user-settings/user-settings-routes').then((routes) => routes.userSettingsRoutes),
        // canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    // {
    //     path: 'address-book',
    //     loadComponent: () => import('./features/address-book/ui/pages/address-book/address-book.component').then((c) => c.AddressBookComponent),
    //     loadChildren: () => import('./features/address-book/address-book-routes').then((routes) => routes.addressBookRoutes),
    //     // canMatch: [authGuard],
    //     resolve: { user: userResolver },
    // },
    // {
    //     path: 'profile',
    //     loadComponent: () => import('./features/profile/ui/pages/profile/profile.component').then((c) => c.ProfileComponent),
    //     loadChildren: () => import('./features/profile/profile-routes').then((routes) => routes.ProfileRoutes),
    //     // canMatch: [authGuard],
    //     resolve: { user: userResolver },
    // },
    // {
    //     path: 'legal',
    //     loadComponent: () => import('./features/legal/ui/pages/legal/legal.component').then((c) => c.LegalComponent),
    //     loadChildren: () => import('./features/legal/legal-routes').then((routes) => routes.LegalRoutes),
    //     // canMatch: [authGuard],
    //     resolve: { user: userResolver },
    // },
    {
        path: 'impersonation-error',
        loadComponent: () => import('./features/impersonation/ui/pages/error/error').then((c) => c.ErrorComponent),
    },
    { path: '**', redirectTo: 'login' },
];
